import { Component, OnInit } from '@angular/core';
// import { NbThemeService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './@core/services/authentication.service';
import { NatLanguage } from './@core/models/nat-language';

@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(
    public authenticationService: AuthenticationService,
    private translateService: TranslateService
  ) {
    if (this.authenticationService.currentUserValue != null) {
      if (this.authenticationService.currentUserValue.language) {
        this.translateService.use(
          this.authenticationService.currentUserValue.language ===
            NatLanguage.En
            ? 'en'
            : 'fr'
        );
      } else {
        this.translateService.use(navigator.language.slice(0, 2) || 'fr');
      }
    } else {
      this.translateService.setDefaultLang(
        navigator.language.slice(0, 2) || 'fr'
      );
      this.translateService.use(navigator.language.slice(0, 2) || 'fr');
    }
  }

  ngOnInit() {}
}
